import styled from 'styled-components'

export const MContentContainer = styled.div<{ isDarkMode?: any }>`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	position: relative;
	padding: 0;
	flex: 1;
	background: ${props => props.theme.COLORS.backgroundColor || props.theme.COLORS.background};
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	overflow: hidden;

	/* 그라데이션 배경 효과 */
	background-image: ${props => `
		linear-gradient(135deg,
			${props.theme.COLORS.point}08 0%,
			transparent 50%,
			${props.theme.COLORS.point}05 100%
		)
	`};

	/* 블러 원형 효과 - 좌상단 (모바일 최적화) */
	&::before {
		content: '';
		position: absolute;
		width: 400px;
		height: 400px;
		background: ${props => props.theme.COLORS.point};
		opacity: ${props => props.isDarkMode ? 0.04 : 0.06};
		filter: blur(80px);
		border-radius: 50%;
		top: -200px;
		left: -150px;
		pointer-events: none;
		z-index: -1;
	}

	/* 블러 원형 효과 - 우하단 (모바일 최적화) */
	&::after {
		content: '';
		position: absolute;
		width: 350px;
		height: 350px;
		background: ${props => props.theme.COLORS.point};
		opacity: ${props => props.isDarkMode ? 0.03 : 0.05};
		filter: blur(70px);
		border-radius: 50%;
		bottom: -150px;
		right: -100px;
		pointer-events: none;
		z-index: -1;
	}

	/* 자식 요소들이 배경 위에 표시되도록 */
	& > * {
		position: relative;
		z-index: 1;
	}

	/* ::-webkit-scrollbar {
		display: none !important;
	}

	::-moz-scrollbar {
		display: none !important;
	} */
`

export const MView = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	flex-direction: column;
`

export const MNOANIView = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	flex-direction: column;

	& > * {
		animation-duration: 0s !important;
	}
`

export const MText = styled.div<{
	size?: number
	hoverColor?: string
}>`
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	flex-direction: row;
	font-family: 'Roboto';
	color: ${props => props.theme.COLORS.textw};
	font-size: 12px;
	&:hover {
		${({ hoverColor }) => hoverColor && `color: ${hoverColor} !important;`}
	}
	@media screen and (max-width: 800px) and (min-width: 600px) {
		font-size: 14px;
	}
`
